'use client'

import { useAnimateOnVisible } from '@hooks/useAnimateOnVisible'
import { AckoIdentityMock } from '@components/MediaKit/MediaKitMock'
import DownloadButton from '@components/MediaKit/DownloadButton/DownloadButton'
import styles from './AckoIdentity.module.scss'
import AckoIdentityLogo from './AckoIdentityLogo'

const AckoIdentity = () => {
  const { ref, animationClassName } = useAnimateOnVisible<HTMLDivElement>()
  return (
    <div ref={ref} className={`${styles.ackoIdentityContainer} ${animationClassName}`}>
      <div className={styles.ackoIdentityHeadingContainer}>
        <p className={styles.ackoIdentityTitle}>{AckoIdentityMock.title}</p>
        <p className={styles.ackoIdentityDescription}>{AckoIdentityMock.description}</p>
      </div>
      <div className={styles.ackoIdentityLogos}>
        {AckoIdentityMock.images.map(imgData => (
          <AckoIdentityLogo {...imgData} />
        ))}
      </div>
      <DownloadButton
        url={AckoIdentityMock.url}
        ctaText={AckoIdentityMock.ctaText}
        journey={AckoIdentityMock.journey}
        newPage={false}
      />
    </div>
  )
}

export default AckoIdentity
